import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  CustomButton,
  CustomCheckbox,
} from "../../../../v2/MUI_custom_component";
import { toCapitalized } from "../../../../v2/Utils/Capitalize";
import digilockerVerifiedImg from "../../../../assets/Digilocker-verified.svg";
import { CONSENT_TEXT } from "../../utils/consentText";

dayjs.extend(customParseFormat);

const DigiLockerReview = ({ digiLockerData, roleName, onContinue }) => {
  const [consent, setConsent] = useState(false);
  const parsedDob = digiLockerData?.date_of_birth
    ? dayjs(digiLockerData.date_of_birth, ["YYYY-MM-DD", "DD-MM-YYYY"])
    : null;
  const dob = parsedDob?.isValid() ? parsedDob.format("DD MMMM YYYY") : "-";

  const fullName = [digiLockerData?.firstname, digiLockerData?.lastname]
    .filter(Boolean)
    .join(" ");
  const fields = [
    { label: "Name", value: toCapitalized(fullName) || "-" },
    { label: "Gender", value: toCapitalized(digiLockerData?.gender || "-") },
    { label: "Date of Birth", value: dob },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
        width: "100%",
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "616px",
          maxWidth: "100%",
        }}>
        <Box
          component="img"
          src={digilockerVerifiedImg}
          alt="DigiLocker Verified"
          sx={{ width: 200, height: 74, objectFit: "contain" }}
        />

        <Typography variant="h2" sx={{ color: "#333333" }}>
          {roleName ? `${roleName} Details` : "User Details"}
        </Typography>

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          {fields.map((f) => (
            <Box key={f.label} sx={{ minWidth: 132, flex: "1 0 0" }}>
              <Typography
                variant="labelM"
                sx={{ color: "#666666", display: "block" }}>
                {f.label}
              </Typography>
              <Typography variant="p1" sx={{ color: "#333333" }}>
                {f.value}
              </Typography>
            </Box>
          ))}
        </Box>

        <CustomCheckbox
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          label={CONSENT_TEXT}
          alignment="flex-start"
        />
      </Box>

      <Box sx={{ width:"616px", maxWidth: "100%" }}>
        <CustomButton
          label="Continue"
          fullWidth
          disabled={!consent}
          onClick={onContinue}
        />
      </Box>
    </Box>
  );
};

export default DigiLockerReview;
